// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"91":"48f2f2c6","677":"921a6dcd","740":"ff0a7bcb"}[chunkId] + ".chunk.css";
};